import { CodePreview } from '@/features/editor/CodePreview';
import { MessagesPanel } from '@/features/console/MessagesPanel';
import { SerialMonitor } from '@/features/serial/SerialMonitor';
import { SKYROVER_COLORS } from '@/theme/skyroverTheme';
import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';

export function RightPanel() {
  const [tab, setTab] = useState<'messages' | 'serial'>('messages');

  return (
    <Box
      sx={{
        width: { xs: '100%', md: 360 },
        minWidth: { md: 320 },
        maxWidth: { md: 420 },
        display: 'flex',
        flexDirection: 'column',
        borderLeft: '1px solid',
        borderColor: 'divider',
        bgcolor: SKYROVER_COLORS.rightPanel,
        flexShrink: 0,
      }}
    >
      <Box sx={{ flex: '1 1 55%', minHeight: 180, display: 'flex', flexDirection: 'column' }}>
        <CodePreview />
      </Box>

      <Box
        sx={{
          flex: '1 1 45%',
          minHeight: 160,
          display: 'flex',
          flexDirection: 'column',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Tabs
          value={tab}
          onChange={(_, v: 'messages' | 'serial') => setTab(v)}
          sx={{
            minHeight: 36,
            bgcolor: '#fff',
            borderBottom: '1px solid',
            borderColor: 'divider',
            '& .MuiTab-root': { color: 'text.secondary' },
            '& .Mui-selected': { color: 'primary.main' },
            '& .MuiTabs-indicator': { bgcolor: 'primary.main', height: 3 },
          }}
        >
          <Tab label="Messages" value="messages" />
          <Tab label="Serial" value="serial" />
        </Tabs>

        <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
          {tab === 'messages' ? <MessagesPanel /> : <SerialMonitor compact />}
        </Box>
      </Box>
    </Box>
  );
}
